import React from "react";
import ReactDOM from "react-dom";
import Config from "./app/config";
import App from "./App";
import "./assets/styles/main.scss";

if (typeof (window as any).oqaliSearchEngine !== "undefined") {
    Config.setBaseUrl((window as any).oqaliSearchEngine.baseUrl);
} else {
    Config.setBaseUrl("/");
}

/**
 * Injecte le style de wordpress si nécessaire
 */
function injectWpCss() {
    const href = `${process.env.REACT_APP_WP_URL}/app/themes/oqali-website-2021/dist/styles/main.css`;
    const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).find((l) => {
        const href = l.getAttribute("href") || "";
        return href.endsWith("oqali-website-2021/dist/styles/main.css") || /oqali-website-2021\/dist\/styles\/main-\d+\.css$/.test(href);
    });
    if (existing) {
        return;
    }

    const masterStyleWp = document.createElement("link");
    masterStyleWp.rel = "stylesheet";
    masterStyleWp.type = "text/css";
    masterStyleWp.href = href;
    document.head.appendChild(masterStyleWp);
}

/**
 * Injection du style react pour les déploiements
 */
function injectReactCss() {
    if (process.env.NODE_ENV === 'development') {
        return;
    }
    const linkReact = document.createElement("link");
    linkReact.rel = "stylesheet";
    linkReact.type = "text/css";
    linkReact.href = `${process.env.REACT_APP_URL}/oqali-search-engine.css`;
    document.head.appendChild(linkReact);
}

/**
 * On s'assure que le css react est chargé après WP
 */
function reorderReactCss() {
    const links = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
    const reactCss = links.find((l) => l.getAttribute("href")?.includes("oqali-search-engine.css"));

    if (reactCss) {
        document.head.removeChild(reactCss);
        document.head.appendChild(reactCss);
    }
}

injectReactCss();
injectWpCss();
reorderReactCss();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("oqali-search-engine-container")
);
